import api from 'utils/api'

export const sendImpression = (offerId, info) => {
  return api.put(`/offer/${offerId}/impression`, { info }).catch(() => {})
}

export const listingType = {
  card: 'card',
  list: 'list',
}

export const unavailableOfferLabel = 'Unavailable'

export const offerAvailabilitySx = (active, isPreview) => (
  isPreview || active
    ? {}
    : { filter: 'grayscale(0.85)', opacity: 0.58 }
)
